// /parquet-viewer — a single full-width Parquet viewer, no second pane and no
// Compare button. Composition only; the wiring lives in ui/parquet-viewer-app.js
// and the reading in lib/document-load.js, both shared with the comparison page.
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/viewer-page.css';
import { header } from './components/header.js';
import { footer } from './components/footer.js';
import { initPromo } from './components/promo.js';
import { track, trackPageView, trackVisitRecency } from './lib/analytics.js';
import { parquetViewerPage } from './components/parquet-viewer-page.js';
import { initTheme } from './lib/theme.js';
import { initViewerPage } from './ui/parquet-viewer-app.js';

initTheme();

document.getElementById('app').innerHTML = `
  ${header({ current: 'viewer' })}
  ${parquetViewerPage()}
  ${footer()}
`;

initPromo();
initViewerPage({ report: track });

// Register the offline service worker here too, so a visitor whose first landing
// is the viewer still gets the app cached (prod/preview only — never dev).
// Every page reports its own view. Without this only the home page was counted,
// which made this page invisible AND quietly inflated nothing — the funnel's
// denominator was home-only while the house ad on this very page was reporting
// impressions (REL-071).
trackPageView('viewer');
trackVisitRecency();

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  addEventListener('load', () => navigator.serviceWorker.register('/service-worker.js').catch(() => {}));
}
